var Vendd = (function (Vendd) {
	'use strict';

	var pending = false;

	Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.GetModel, Vendd.Wishlist, function (envelope) {

		if (LhApp.Context.MultipleWishlistsEnabled) {
			Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.UserWishlist.Messages.GetModel());

			if (LhApp.Context.Item.Template != 'wishlist')
				return true;
		}

		if (pending === true) {
			return false;
		};

		function onSuccess(response) {
			model = response.data ? $.extend({}, response.data, { LangCode: LhApp.Context.Language, CurrCode: LhApp.Context.Currency.Code }) : response.data;
			Vendd.Wishlist.SetClientModel(model);
			Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Changed(model));

			pending = false;
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));

			pending = false;
		}

		var itemId = 0, templateCode = "";
		if (LhApp.Context.Item !== undefined) {
			itemId = LhApp.Context.Item.Id;
		}

		if (LhApp.Context.Item) {
			templateCode = LhApp.Context.Item.Template;
		}

		var visitorListId = Vendd.Wishlist.GetVisitorListByQueryString();

		var options = {
			data: { currentItemId: itemId, templateCode: templateCode, visitorListId: visitorListId },
			url: 'api/Wishlist/GetWishlistViewModel' + '?lang=' + LhApp.Context.Language, //todo perikstath -> this should be resolved by the rewriter and be like /el/
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		if (model != null && model != undefined && Vendd.Wishlist.GetClientModel() != null && document.cookie.indexOf('ForceClearWishlistLocalStorage') == -1) {

			Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Changed(model));
			return true;
		}

		Cookies.remove('ForceClearWishlistLocalStorage', { path: '/' });
		pending = true;

		Vendd.Service.call(options);

	});

	Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, Vendd.Wishlist, function (envelope) {
		if (envelope && !envelope.message.data.IsLocalStorageCache)
			Vendd.MessageBus.publishAsync(Vendd.Newsletter, new Vendd.Newsletter.Messages.UpdateNewLetterVariables(1, null));
	});

	Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Add, Vendd.Wishlist, function (envelope) {
		var data = {};
		data.item = envelope.message.data;

		var options = {
			url: 'EcomService.svc/AddToWishlist',
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.Wishlist.ClearClientModel();

			if (LhApp.Context.MultipleWishlistsEnabled)
				Vendd.UserWishlist.ClearClientModel();

			if (response.success) {

				if (response.code === 'OperationSuccesful') {
					Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.AddSuccess(envelope.message.data.id, envelope.message.data.skuId, response));
				}

				if (response.code === 'ValidationError' || response.code == 'RequiresAuthenticationError') {
					Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Warning(response));
				}

				if (response.code !== 'RequiresAuthenticationError') {
					Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.GetModel());
				}

			} else {
				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
			}

		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
		}

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.MultipleAdd, Vendd.Wishlist, function (envelope) {
		var data = {
			items: envelope.message.data
		};

		var options = {
			url: 'EcomService.svc/AddItemsToWishlist',
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		function onSuccess(response) {
			Vendd.Wishlist.ClearClientModel();

			if (LhApp.Context.MultipleWishlistsEnabled)
				Vendd.UserWishlist.ClearClientModel();

			if (response.success) {

				if (response.code === 'OperationSuccesful') {
					Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.MultipleAddSuccess(envelope.message.data.id, envelope.message.data.skuId, response));
				}

				if (response.code === 'ValidationError' || response.code == 'RequiresAuthenticationError') {
					Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Warning(response));
				}

				if (response.code !== 'RequiresAuthenticationError') {
					Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.GetModel());
				}

			} else {
				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
			}

		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
		}

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Remove, Vendd.Wishlist, function (envelope) {

		var data = LhApp.Context.MultipleWishlistsEnabled && !envelope.message.data.visitorListId
			? $.extend({}, envelope.message.data, { visitorListId: Vendd.Wishlist.GetVisitorListByQueryString() })
			: envelope.message.data;

		function onSuccess(response) {
			Vendd.Wishlist.ClearClientModel();

			if (LhApp.Context.MultipleWishlistsEnabled)
				Vendd.UserWishlist.ClearClientModel();


			if (response.success) {
				var removedProduct = model.Items.find(function (x) { return envelope.message.data.id == x.Id; });


				if (response.code === 'OperationSuccesful') {
					Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.RemoveSuccess(removedProduct.ProductId, removedProduct.VariantId, response));
				}

				if (response.code === 'ValidationError' || response.code == 'RequiresAuthenticationError') {
					Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Warning(response));
				}

				if (response.code !== 'RequiresAuthenticationError') {
					Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.GetModel());
				}
			} else {
				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/RemoveFromWishlist',
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.MoveToCart, Vendd.Wishlist, function (envelope) {

		var data = LhApp.Context.MultipleWishlistsEnabled && !envelope.message.data.listId
			? $.extend({}, envelope.message.data, { listId: Vendd.Wishlist.GetVisitorListByQueryString() })
			: envelope.message.data;

		function onSuccess(response) {
			if (response.success && (response.code === 'OperationSuccesful' || response.code === 'OperationSuccesfulLastPieceAddedToCart')) {
				var movedToCartProduct = model.Items.find(function (x) { return envelope.message.data.id == x.Id; });
				Vendd.Wishlist.ClearClientModel();
				Vendd.Cart.ClearClientModel();

				if (LhApp.Context.MultipleWishlistsEnabled)
					Vendd.UserWishlist.ClearClientModel();

				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.ProductAdded(movedToCartProduct.ProductId, movedToCartProduct.VariantId, response.data));
				Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.GetModel());
				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Cart.Messages.ShowMessages(response));
				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Cart.Messages.GetModel());
			} else if (response.success && response.code === 'ValidationError') {
				Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Warning(response));
			} else
				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/MoveWishlistProductToCart',
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.UpdateItemQuantity, Vendd.Wishlist, function (envelope) {
		function onSuccess(response) {
			if (response.success) {
				Vendd.Wishlist.ClearClientModel();

				if (LhApp.Context.MultipleWishlistsEnabled)
					Vendd.UserWishlist.ClearClientModel();

				Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.GetModel());
			} else
				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
		}

		var data = envelope.message.data;

		var options = {
			url: 'EcomService.svc/UpdateWishlistItemQuantity',
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.MoveAllToCart, Vendd.Wishlist, function (envelope) {

		var data = { listId: Vendd.Wishlist.GetVisitorListByQueryString() };

		function onSuccess(response) {
			if (response.success) {
				Vendd.Wishlist.ClearClientModel();
				Vendd.Cart.ClearClientModel();

				if (LhApp.Context.MultipleWishlistsEnabled)
					Vendd.UserWishlist.ClearClientModel();

				if (response.code === 'OperationSuccesful' || response.code === 'PartialValidationError') {
					toastr.success(LhApp.Function.getText("Common:AllProductsAddedToCart"), "", { timeOut: 1200, showDuration: 400, hideDuration: 700 });
					Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.GetModel());
					Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Cart.Messages.ShowMessages(response));
					Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Cart.Messages.GetModel());
				}

				if (response.code === 'PartialValidationError') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Warning(response));
				}

				if (response.code === 'ValidationError') {
					Vendd.MessageBus.publishAsync(Vendd.Cart, new Vendd.Cart.Messages.Warning(response));
				}

			} else {
				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
			}
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/MoveWishlistToCart',
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Clear, Vendd.Wishlist, function (envelope) {
		var listId = Vendd.Wishlist.GetVisitorListByQueryString(), model;

		if (listId == 0) {
			model = JSON.parse(localStorage.getItem("CurrentWishlistModel"));
			listId = model.ListId;
		}

		var data = { listId: listId };

		function onSuccess(response) {
			if (response.success) {
				Vendd.Wishlist.ClearClientModel();

				if (LhApp.Context.MultipleWishlistsEnabled)
					Vendd.UserWishlist.ClearClientModel();

				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.ClearSuccess());
				Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.GetModel());
			} else
				Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
		}

		function onFailure(response) {
			Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.Failed(response));
		}

		var options = {
			url: 'EcomService.svc/ClearWishlist',
			data: data,
			onSuccess: onSuccess,
			onFailure: onFailure
		};

		Vendd.Service.call(options);
	});

	var dontLoadOnLoginSuccess;
	Vendd.MessageBus.subscribe(Vendd.User.Messages.Login, Vendd.Wishlist, function (envelope) {
		dontLoadOnLoginSuccess = envelope.message.data.options && envelope.message.data.options.isLoginForm;
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, Vendd.Wishlist, function (envelope) {
		if (dontLoadOnLoginSuccess)
			return;
		Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.GetModel());
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutSuccess, Vendd.Wishlist, function (envelope) {
		Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.Wishlist.Messages.GetModel());
	});


	Vendd.Wishlist.ClearClientModel = function () {
		localStorage.removeItem('CurrentWishlistModel');
	};

	Vendd.Wishlist.GetClientModel = function () {
		var mdl = JSON.parse(localStorage.getItem("CurrentWishlistModel"));

		return LhApp.Function.validateClientModel(mdl)
			? $.extend({ IsLocalStorageCache: true }, mdl)
			: null;
	};

	Vendd.Wishlist.SetClientModel = function (mdl) {
		localStorage.setItem('CurrentWishlistModel', JSON.stringify(mdl));
	};

	Vendd.Wishlist.GetVisitorListByQueryString = function () {
		return LhApp.Function.QueryString.getValueOf('list', unescape(LhApp.Context.Request.RawUrl)) || 0;
	};

	var model = Vendd.Wishlist.GetClientModel();

	//this should be moved to every component that requires this component's data. e.g. login widget AND in case your page DOES NOT contain that widget then you have to make sure theres somewhere this call 
	(function () {
		var defaultCallExecuted;
		function defaultCall() {
			if (Vendd.User.SessionState && !defaultCallExecuted) {
				defaultCallExecuted = true;

				if (Vendd.User.SessionState.IsNewSession)
					Vendd.User.ClearClientModel();

				if (venddProjectConfigs.WishlistModelEnabled && !venddProjectConfigs.SiteIsLocked) {
					Vendd.MessageBus.publishAsync(Vendd.Wishlist, new Vendd.Wishlist.Messages.GetModel());
				}
			}
		}
		defaultCall();
		Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, Vendd.Wishlist, function (envelope) {
			defaultCall();
		});
	})();

	return Vendd;

})(Vendd || {});